module.exports = __webpack_public_path__ + "static/media/residential-low-rise.fa65d445.svg";